import styled from "styled-components";

const HeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  outline: none;
  align-items: center;

  height: 100%;

  .separator {
    width: 1px;
    height: 48px;
    box-sizing: border-box;
    margin: 0 16px;
    border-right: 1px solid ${({ theme }) => theme.colors.base3};
  }

  @
`;

export default HeaderActions;
